<template>
    <div class="feedback-experience">
        <body-feedback 
            :index="index"
            :beforeBold="$t('views.feedback.experience.beforeBold')"
            :titleBold="$t('views.feedback.experience.titleBold')"
            actionName="sendExperience">
            <experience-list :itensList="experienceStatus"></experience-list>
            <div class="acceptance-contact" @click="setAcceptContactValue(acceptContact = !acceptContact)">
                <div class="unchecked" v-if="!acceptContact" :style="{'background-color' : colors.theme == 'dark' ? '#001420' : '#191919'}"></div>
                <img class="image-check" v-else src="/img/icons/feedback-checked.png" :style="{'background-color' : colors.theme == 'dark' ? '#001420' : '#191919'}" alt="">
                <span :style="{ color: colors.theme == 'dark' ? '#fff' : '#000' }">{{$t("views.feedback.contactAuthorization")}}</span>
            </div>
        </body-feedback>
    </div>
</template>
<script>
import BodyFeedback from '../../components/feedback/BodyFeedback.vue'
import ExperienceList from '../../components/feedback/ExperienceList.vue'
import { Bus } from '../../event-bus.js'
export default {
    components:{
        BodyFeedback,
        ExperienceList
    },
    props:["index"],
    data(){
        return{
            experienceStatus : [
                { value : 'excellent', descricao : this.$t("views.feedback.experience.experienceStatusDescription[0]") },
                { value : 'good', descricao : this.$t("views.feedback.experience.experienceStatusDescription[1]") },
                { value : 'regular', descricao : this.$t("views.feedback.experience.experienceStatusDescription[2]") },
                { value : 'bad', descricao : this.$t("views.feedback.experience.experienceStatusDescription[3]") },
                { value :'terrible', descricao : this.$t("views.feedback.experience.experienceStatusDescription[4]") }
            ],
            acceptContact: '',
            colors: {}
        }
    },
    created(){
        Bus.$on('sendExperience', this.sendExperience)
        localStorage.removeItem("acceptContact"),
        this.colors = JSON.parse(localStorage.getItem("colors"));
        // console.log("____INDEX: ", this.index)

    },
    methods: {
        sendExperience(){
            Bus.$emit('nextStep')
            this.$router.push('/feedback-preference')
        },
        setAcceptContactValue(){
            localStorage.setItem("acceptContact", this.acceptContact)
        }        
    }
}
</script>
<style lang="scss" scoped>
    .feedback-experience{
        height: 100%;
        width: 100%;

        .acceptance-contact{
            padding: 32px;
            text-align: justify;
            font-size: 14px;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover{
                cursor: pointer;
            }            

            input{
                display: none
            }
            img, .unchecked{
                // background-color: #6b0063;
                border-radius: 5px;
                min-width: 25px;
                height: 25px;
                padding: 5px;
                margin: 0 10px 0 0;
            }            
        }         
    }
</style>
